<template>
  <v-footer fixed class="grey lighten-4" height="60">
    <v-layout row wrap align-center>
      <v-flex xs12>
        <div class="ml-3">
          <a itemprop="telephone" href="tel:001-626-390-8870">
            <v-icon size="18">fas fa-phone</v-icon>
            <span class="grey--text--dark-2 pl-2">626-390-8870</span></a>
          <span class="pl-3"></span>
          <a itemprop="email" href="mailto:juliazhao@remax.net">
            <v-icon size="18">fas fa-envelope</v-icon>
            <span class="grey--text--dark-2 pl-2">juliazhao@remax.net</span></a>
        </div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
   export default {
        name: "home-footer"
    }
</script>

<style scoped>
a {
  text-decoration: none;
  color: unset;
}
</style>
